import render from './render'

export default {
  name: 'FilterByTag',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
